import { ChangeDetectorRef, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { TableDataType } from '../../../global/model/ExportColumn';
import { SearchCoreComponent } from '../../../global/component/search-core/search-core.component';
import { JsonPipe, NgFor, NgIf } from '@angular/common';
import { GenericButtonComponent } from "../../../global/component/generic/generic-button/generic-button.component";
import { EventModalComponent } from "../../shared-components/event-modal/event-modal.component";
import { EventModel } from '../../models/EventModel';

// primeng components ---------------------------------------------------------------------
import { TagModule } from 'primeng/tag';
import { InputIconModule } from 'primeng/inputicon';
import { FormsModule } from '@angular/forms';
import { CheckboxModule } from 'primeng/checkbox';
import { MainModel } from '../../../global/model/MainModel';

@Component({
  selector: 'app-fundraisers-events',
  standalone: true,
  imports: [SearchCoreComponent, CheckboxModule, NgFor, NgIf, GenericButtonComponent, JsonPipe, EventModalComponent, TagModule, InputIconModule, FormsModule],
  templateUrl: './events-search.component.html',
  styleUrl: './events-search.component.scss'
})
export class FundraisersEventsComponent implements OnInit{

  constructor( protected model: MainModel,
      private cd: ChangeDetectorRef
     )
  {
    
  }

  ngOnInit(): void {
      this.showSearch = true;
  }

  showSearch:boolean = false;

  // SEARCH UI CONFIGURING VARIABLES =========================================
  eventsDataType:TableDataType = TableDataType.Events;
  @ViewChild('searchUI') searchUI!: SearchCoreComponent;

  // LOCAL STATE =============================================================== 
  protected selectedRows: any[] = [];
  protected lastClicked: EventModel|undefined = undefined;
  protected showDeleteConfirmModal:boolean = false;
  protected showEditConfirmModal:boolean = false;
  
  // this should open a side panel to edit an event...
  triggerDelete(item:EventModel){
    this.lastClicked = item;
    this.showDeleteConfirmModal = true;
  }

  // this should open a side panel to edit an event...
  triggerEdit(item:EventModel){
    this.lastClicked = item;
    this.showEditConfirmModal = true;
  }

  resetState(event:any){
    this.lastClicked = undefined;
    this.showDeleteConfirmModal = false;
    this.showEditConfirmModal = false;
  }
  
  // this should open a side panel to edit an event...
  selectedAction(event:Event, item:any){
    if(!item.isChecked){
      item.isChecked = true;
    } else {    
      item.isChecked = !  true;
    }
    item = item as EventModel;
    const checkbox = event.target as HTMLInputElement;
    if(checkbox.checked){
      this.selectedRows.push(item);
    } else {
      this.selectedRows = this.selectedRows.filter(i => i.EventID !== item.EventID);
    }
  }

  getIsChecked(allC:boolean , item:any){
    return allC || item.isChecked;
  }

  setItemActive(item:any, event:Event){
    console.debug(item);
  }
}
